
import { commonfunc } from '~/mixin/common'
import { ugMixin } from '~/mixin/ug/ugMixin'

export default {
  name: 'ContQuick',
  filters: {
    comma: (val) => {
      let num = Number(val)
      if (num > 9999) {
        num = 9999
      }
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    }
  },
  mixins: [commonfunc, ugMixin],
  props: {
    main: {
      type: Boolean,
      default: false
    },
    isLike: {
      type: String,
      default: 'N'
    },
    isZzim: {
      type: String,
      default: 'N'
    },
    ctenId: {
      type: String,
      default: ''
    },
    likeCnt: {
      type: String,
      default: '0'
    },
    zzimCnt: {
      type: String,
      default: '0'
    },
    ancmCnt: {
      type: String,
      default: '0'
    },
    lgnMbMngNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      likeCntTemp: '0',
      isLikeTemp: '',
      ancmCntTemp: '0',
      zzimCntTemp: '0',
      isZzimTemp: '',
      quickList: [

      ],
      isPc: true,
      isCtenMb: false,
      disabled: true,
      srchForm: {
        mbMngNo: '',
        lgnMbMngNo: ''
      },
      wtgDtlForm: {
        frWtgLongCtenRwd: '',
        frWtgShrfCtenRwd: '',
        frWtgShrtCtenRwd: '',
        wtgLongCtenRwd: '',
        wtgShrfCtenRwd: '',
        wtgShrtCtenRwd: ''
      }
    }
  },
  watch: {
    likeCnt (val) {
      this.quickList[0].count = val
    },

    zzimCnt (val) {
      this.quickList[2].count = val
    },

    ancmCnt (val) {
      this.quickList[1].count = val
    },

  },
  mounted () {
    this.srchForm.lgnMbMngNo = this.lgnMbMngNo
    this.srchForm.mbMngNo = this.lgnMbMngNo
    this.display()
    // this.lgnMbMngNo = this.$store.getters['session/getMbMngNo']
    this.selCtenRwd() // 콘텐츠커머스 작성 리워드 조회
  },
  methods: {
    validMb () {
      // document.getElementsByClassName('quick-btn-write')[0].disabled = true

      const mbInfo = this.$store.getters['session/getMb']
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      console.log('validMb : ', mbMngNo)
      if (mbMngNo === '' || mbMngNo === undefined) {
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      } else if (mbInfo.userTy === '40' || mbInfo.userTy === '50') {
        this.$alert('일반회원만 작성 가능합니다.')
        return
      }

      this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('/ug/common/selCtenMb')
        .then((res) => {
          console.log(res)
          if (res.data.success) {
            this.isCtenMb = true
            this.isShow = true
          } else {
            this.isShow = false
            this.$confirm(this.$t('UG.REG_PROFILE'), '', {
              cancelButtonText: '취소',
              confirmButtonText: '확인'
            }).then(() => {
              this.$router.push({ name: 'ug-ugp-SCR_UGP_0018', params: { returnUrl: this.$route.fullPath } })
            }).catch(() => {
              return false
            })
            return false
          }
        }).catch((err) => {
          console.log(err)
        })

      // this.isShow = false
    },
    toTop () {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    selCtenRwd () {
      this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('/ug/common/selCtenRwd')
        .then((res) => {
          this.wtgDtlForm.frWtgLongCtenRwd = res.data.data.frWtgLongCtenRwd // 긴글 첫 작성 리워드
          this.wtgDtlForm.frWtgShrtCtenRwd = res.data.data.frWtgShrtCtenRwd // 짧은글 첫 작성 리워드
          this.wtgDtlForm.frWtgShrfCtenRwd = res.data.data.frWtgShrfCtenRwd // 쇼츠 첫 작성 리워드
          this.wtgDtlForm.wtgLongCtenRwd = res.data.data.wtgLongCtenRwd // 긴글 작성 리워드
          this.wtgDtlForm.wtgShrtCtenRwd = res.data.data.wtgShrtCtenRwd // 짧은글 작성 리워드
          this.wtgDtlForm.wtgShrfCtenRwd = res.data.data.wtgShrfCtenRwd // 쇼츠 작성 리워드
        })
    },
    display () {
      this.likeCntTemp = this.likeCnt
      this.isLikeTemp = this.isLike
      this.ancmCntTemp = this.ancmCnt
      this.zzimCntTemp = this.zzimCnt
      this.isZzimTemp = this.isZzim

      this.quickList = [
        {
          name: '좋아요',
          class: 'like',
          count: this.likeCntTemp,
          active: this.isLikeTemp === 'Y'
        },
        {
          name: '댓글',
          class: 'comment',
          count: this.ancmCntTemp,
          active: false
        },
        {
          name: '북마크',
          class: 'bookmark',
          count: this.zzimCntTemp,
          active: this.isZzimTemp === 'Y'
        }

      ]

      // 긴글 disabled
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { // Mobile
        this.isPc = false
      }
    },
    clickQuickItem (quickItem) {
      const act = {}
      if (quickItem.class !== 'comment') { // 댓글아니면 로그인필요
        if (this.lgnMbMngNo === '' || this.lgnMbMngNo === undefined) {
          this.loginAlert()
          return
        }
      } else { // 댓글이면 로그인불필요
        act.avtTy = 'cmt'
        this.$emit('updMbAct', act)
      }

      quickItem.active = !quickItem.active

      if (quickItem.class === 'like') {
        act.avtTy = 'L'
        if (quickItem.active) {
          act.likeActTy = 'P'
          act.isLike = 'Y'
        } else {
          act.likeActTy = 'M'
          act.isLike = ''
        }
        this.ctenAvt(act)
      } else if (quickItem.class === 'bookmark') {
        act.avtTy = 'S'
        if (quickItem.active) {
          act.zzimActTy = 'P'
          act.isZzim = 'Y'
        } else {
          act.zzimActTy = 'M'
          act.isZzim = ''
        }
        this.ctenAvt(act)
      }
    },
    clickViewProd () {
      const act = {}
      act.avtTy = 'pd'
      this.$emit('updMbAct', act)
    },
    clickShare () {
      const act = {}
      act.avtTy = 'sns'
      this.$emit('updMbAct', act)
    },
    ctenAvt (act) {
      act.ctenId = this.ctenId
      act.lgnMbMngNo = this.lgnMbMngNo

      const url = act.avtTy === 'L' ? '/ug/common/updCtenLike' : '/ug/common/updCtenZzim'

      this.$AxiosBuilder
        .data(act)
        .build()
        .post(url)
        .then((res) => {
          if ((!res.data.data.success && res.data.data.returnCode === '-1')) {
            this.isLikeTemp = 'N'
            this.$confirm(this.$t('UG.REG_PROFILE_FOR_LIKE'), { center: true, dangerouslyUseHTMLString: true }).then(() => {
              this.$router.push({ name: 'ug-ugp-SCR_UGP_0018', params: { returnUrl: this.$route.fullPath } })
            }).catch(() => {
              return false
            })
          } else if (!res.data.success) {
            this.isLikeTemp = 'N'
          } else if (act.avtTy === 'L') {
            if (act.likeActTy === 'P') {
              this.isLikeTemp = 'Y'
              this.quickList[0].count = Number(this.quickList[0].count) + 1
              this.openToast(this.$t('UG.CONTENTS_LIKE_Y'))
              this.$emit('updMbAct', act)
            } else {
              this.isLikeTemp = 'N'
              this.quickList[0].count = Number(this.quickList[0].count) - 1
              this.openToast(this.$t('UG.COMMENT_LIKE_N'))
              this.$emit('updMbAct', act)
            }
          } else if (act.avtTy === 'S') {
            if (act.zzimActTy === 'P') {
              this.quickList[2].count = Number(this.quickList[2].count) + 1
              this.openToast(this.$t('UG.SCRAP_SUCCESS'))
            } else {
              this.quickList[2].count = Number(this.quickList[2].count) - 1
              this.openToast(this.$t('UG.SCRAP_CANCEL'))
            }
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    openToast (msg) {
      this.$notify({
        // title: 'Custom Position',
        message: msg,
        position: 'center',
        showClose: false,
        duration: 3000,
        onClick: () => { this.$notify.closeAll() }
      })
    }
  }
}
